import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[disableScrollOnNumber]'
})
export class DisableScrollOnNumberDirective {
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName === 'INPUT' && (target as HTMLInputElement).type === 'number') {
      (event.target as HTMLElement).blur(); // Remove focus to prevent scroll
      event.preventDefault();
    }
  }
}
